import React, { useEffect } from 'react';

import { Link } from 'react-router-dom';

import { PublicPageTemplate } from 'ui/templates';

import DescriptionCard from 'ui/_components/DescriptionCard/DescriptionCard';
import Button from 'ui/_components/Button/Button';
import descrData from 'ui/staticSiteData/descriptionForServiceProvidersData/data.jsx';
import { defaultMetaTags } from 'default-meta';
import { MetaTags } from 'libs/metaTags';
import { createPage } from 'libs/ssr/createPage';

import s from './description-for-service-providers.page.module.css';
import { useServiceProviderDescription } from './for-service-providers.page.model';

function ForServiceProvidersPage() {
  const {
    isLoading,
    getServiceProviderDescription,
    serviceProviderDescription,
  } = useServiceProviderDescription();

  useEffect(() => {
    getServiceProviderDescription();
  }, []);

  if (!serviceProviderDescription || isLoading) return null;

  return (
    <PublicPageTemplate>
      <MetaTags {...metaTags} />
      <div className={s.pageWrapper}>
        <section className={s.headerBlock}>
          <div className={s.blockContainer}>
            <h1 className={s.title}>
              Register as a Service Provider with Pawzr Today
            </h1>
            <div className={s.helpTitle}>
              Gain access to our full suite of services. In less time
              <br />
              than it takes to walk your dog around the block.
            </div>
            <Link to={'/sign-up-provider'}>
              <Button className={s.button} isOpacity size="big">
                List Your Business
              </Button>
            </Link>
          </div>
        </section>
        <section className={s.blogGrid}>
          {serviceProviderDescription.map((item, i) => (
            <DescriptionCard
              smallDescr={i > 1 && i < 4}
              key={i}
              description={item}
            />
          ))}
        </section>
        <div className={s.buttonRow}>
          <Link to={'/sign-up-provider'}>
            <Button className={s.button} size="big">
              {descrData.en.button.text}
            </Button>
          </Link>
        </div>
      </div>
    </PublicPageTemplate>
  );
}

const metaTags = {
  ...defaultMetaTags,
  title: 'Register Your Business | Pawzr',
};

export default createPage(ForServiceProvidersPage, {
  renderMetaTags: (url, _, host) => <MetaTags {...metaTags} url={url} />,
});
